<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 my-2 pb-4 w-100">
    <div class="d-flex justify-content-between">
      <h1 class="modal-title m-auto pl-2">{{ 'ADD_A_DEVICE' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-3">
    <p class="text-center heading-one">{{ 'NAME_DEVICE' | translate }}</p>
    <p class="paragraph-text text-center px-3 mx-4">
      {{ 'PERSONALIZE_YOUR_DEVICE' | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form
      [formGroup]="deviceNameForm"
      (keyup.enter)="navigateToNextStep()"
      #deviceName
      [attr.autofocus]="focusOnPreviousModal ? '' : null"
      tabindex="0"
    >
      <div class="rounded-top form-field">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'NAME' | translate }}</mat-label>
          <input matInput formControlName="deviceName" />
          <mat-error>
            <span *ngIf="formInstance?.deviceName?.errors?.required">{{
              'YOU_MUST_ENTER_DEVICE_NAME' | translate
            }}</span>
          </mat-error>

          <mat-error
            *ngIf="
              formInstance?.deviceName?.errors?.maxlength &&
              !formInstance?.deviceName?.errors?.requiredSpecialCharForLock
            "
            >{{ 'MAXIMUM_OF_CHARACTER' | translate }}
          </mat-error>
          <mat-error *ngIf="formInstance?.deviceName?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>

          <mat-error>
            <span
              *ngIf="
                formInstance?.deviceName?.errors?.requiredSpecialCharForLock
              "
              >{{ 'YOU_MUST_ENTER_VALID_DEVICE_NAME' | translate }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="row w-100 px-3 py-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!deviceNameForm.valid"
        (click)="navigateToNextStep()"
      >
        {{ 'CONTINUE' | translate }}
      </button>
    </div>
  </div>
</div>
